"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
require("react-modern-calendar-datepicker/lib/DatePicker.css");
const react_modern_calendar_datepicker_1 = __importDefault(require("react-modern-calendar-datepicker"));
//
// styles
//
require("./datePicker.css");
const StyledCalendarDropdown_1 = require("./StyledCalendarDropdown");
const StyledCalendarDropdownText_1 = require("./StyledCalendarDropdownText");
const StyledIcon_1 = require("components/Dashboard/StyledIcon");
const StyledHiddenInput_1 = require("./StyledHiddenInput");
const StyledFooter_1 = require("./StyledFooter");
const StyledCalendarButton_1 = require("./StyledCalendarButton");
const StyledButton_1 = require("./StyledButton");
const StyledDropdownText_1 = require("./StyledDropdownText");
const StyledMenu_1 = require("./StyledMenu");
const StyledInputsContainer_1 = require("./StyledInputsContainer");
const DatePickerInput = (props) => {
    const [showCustom, setShowCustom] = (0, react_1.useState)(false);
    const [showPresets, setShowPresets] = (0, react_1.useState)(false);
    const [selectedRange, setSelectedRange] = (0, react_1.useState)({
        from: null,
        to: null
    });
    const [dateChosen, setDateChosen] = (0, react_1.useState)(false);
    const wrapperRef = (0, react_1.useRef)(null);
    function detectClick(ref) {
        (0, react_1.useEffect)(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowPresets(false);
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }
    detectClick(wrapperRef);
    function handleToggleDropdown() {
        setShowPresets((current) => !current);
    }
    function handleSelectRange(range) {
        setShowPresets(false);
        if (range === 'Custom interval') {
            props.callback(range, true);
            setShowCustom(true);
        }
        else {
            setShowCustom(false);
            props.callback(range, false);
        }
    }
    function handleSelectCustom(range) {
        setSelectedRange(range);
        props.callback(range, true);
        if (selectedRange.from && selectedRange.to) {
            setDateChosen(true);
        }
        if (!selectedRange.from && !selectedRange.to) {
            setDateChosen(false);
        }
    }
    function handleResetRange() {
        setSelectedRange({ from: null, to: null });
        handleSelectRange('Last 7 days');
    }
    (0, react_1.useEffect)(() => {
        if (props.selection.range === 'Custom interval') {
            setShowCustom(true);
            if (props.selection.from.year && props.selection.to.year) {
                setSelectedRange({
                    from: props.selection.from,
                    to: props.selection.to
                });
            }
        }
    }, [props.selection]);
    const renderCustomInput = ({ ref }) => (react_1.default.createElement("div", null,
        react_1.default.createElement(StyledHiddenInput_1.StyledHiddenInput, { id: 'hidden-input' }),
        react_1.default.createElement(StyledCalendarDropdown_1.StyledCalendarDropdown, { ref: ref },
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-calendar', margin: '10px', size: '14px' }),
            react_1.default.createElement(StyledCalendarDropdownText_1.StyledCalendarDropdownText, { id: 'calendar-input', width: dateChosen ? '100px' : '‎80px' }, selectedRange.from && selectedRange.to
                ? // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                    `${selectedRange.from.month}-${selectedRange.from.day}-${selectedRange.from.year} to ${selectedRange.to.month}-${selectedRange.to.day}-${selectedRange.to.year}`
                : '‎'),
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-chevron-down', size: '14px' }))));
    function renderOptions(options) {
        const optionsArray = [];
        options.map((option) => {
            optionsArray.push(react_1.default.createElement(StyledDropdownText_1.StyledDropdownText, { className: 'card-body change-account', key: option, onClick: () => handleSelectRange(option), option: true }, option));
        });
        return (react_1.default.createElement(StyledMenu_1.StyledMenu, { className: `dropdown-menu dropdown-menu-car ${showPresets ? 'show' : ''}` },
            optionsArray,
            react_1.default.createElement(StyledDropdownText_1.StyledDropdownText, { className: 'card-body change-account', id: 'custom-interval', onClick: () => handleSelectRange('Custom interval'), option: true }, "Custom interval")));
    }
    const intervalDropdown = () => {
        return (react_1.default.createElement("div", { className: 'dropdown', ref: wrapperRef },
            react_1.default.createElement(StyledButton_1.StyledButton, { "aria-expanded": 'false', "aria-haspopup": 'true', className: 'btn btn-primary', "data-toggle": 'dropdown', onClick: handleToggleDropdown, radius: '4px', type: 'button' },
                react_1.default.createElement(StyledDropdownText_1.StyledDropdownText, { id: 'preset-range' }, props.selection.range),
                react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-chevron-down', size: '14px' })),
            renderOptions(props.options)));
    };
    let disabled = [];
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (selectedRange.from && selectedRange.from.year) {
        disabled = [
            {
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                year: selectedRange.from.year,
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                month: selectedRange.from.month,
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                day: selectedRange.from.day
            }
        ];
    }
    return (react_1.default.createElement("div", null, showCustom ? (react_1.default.createElement(StyledInputsContainer_1.StyledInputsContainer, null,
        react_1.default.createElement(react_modern_calendar_datepicker_1.default, { calendarClassName: 'custom-calendar', colorPrimary: '#5A1CF4', colorPrimaryLight: '#E5DEFB', disabledDays: disabled, onChange: handleSelectCustom, renderFooter: () => (react_1.default.createElement(StyledFooter_1.StyledFooter, null,
                react_1.default.createElement(StyledCalendarButton_1.StyledCalendarButton, { onClick: handleResetRange, type: 'button' }, "Reset"))), renderInput: renderCustomInput, value: selectedRange }),
        intervalDropdown())) : (react_1.default.createElement(StyledInputsContainer_1.StyledInputsContainer, { single: true }, intervalDropdown()))));
};
DatePickerInput.propTypes = {
    callback: prop_types_1.default.func,
    options: prop_types_1.default.arrayOf(prop_types_1.default.string),
    selection: prop_types_1.default.shape({
        range: prop_types_1.default.string,
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
        to: prop_types_1.default.shape(),
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
        from: prop_types_1.default.shape()
    })
};
exports.default = DatePickerInput;
